// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Linkedin: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 22 22"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M20.429 0H1.567C.702 0 0 .712 0 1.586v18.828C0 21.288.702 22 1.567 22h18.862c.864 0 1.571-.712 1.571-1.586V1.586C22 .712 21.293 0 20.429 0zM6.649 18.857H3.39V8.358h3.265v10.5h-.005zM5.02 6.924a1.891 1.891 0 010-3.781c1.04 0 1.89.85 1.89 1.89 0 1.046-.844 1.891-1.89 1.891zm13.853 11.933h-3.26V13.75c0-1.218-.025-2.784-1.695-2.784-1.7 0-1.96 1.326-1.96 2.696v5.195h-3.26V8.358h3.128v1.434h.044c.437-.825 1.503-1.694 3.089-1.694 3.3 0 3.914 2.175 3.914 5.004v5.755z" />
        </svg>
    );
};

export default React.memo(Linkedin);
